import { init as initI18n, LanguageScopes } from '@pypestream/translations';
import { sentryInit, showGitInfo, isDevelopment } from '@pypestream/utils';
import type { PostHog } from 'posthog-js/react';
import ReactDOM from 'react-dom/client';

import { datadogInit } from './datadog-init';
import { AuthProvider } from './global-provider';
import { XstateDevLogger } from './xstate';

import './index.scss';
import { RouterProvider } from './router';
import { getAnalytics } from './hooks/use-analytics';

let container: HTMLElement | null = null;

const analytics = getAnalytics();
if (analytics) {
  if (typeof analytics.init === 'function') {
    analytics.init(import.meta.env.FE_POSTHOG_API_KEY, {
      api_host: import.meta.env.FE_POSTHOG_API_HOST,
      opt_out_capturing_by_default: true,
      disable_session_recording: true,
      session_recording: {
        recordCrossOriginIframes: true,
        maskAllInputs: false,
        maskTextSelector: '[data-private]',
      },
      capture_pageview: true,
      capture_pageleave: true,
    });
  }

  if (typeof analytics.register === 'function') {
    analytics.register({
      'Pypestream Product': 'Manager',
      'Pypestream Environment': import.meta.env.ANALYTICS_CAPTURE_ENVIRONMENT,
      'Git Commit': import.meta.env.ANALYTICS_CAPTURE_GIT_COMMIT,
      'Git Tags': import.meta.env.ANALYTICS_CAPTURE_GIT_TAGS
        ? import.meta.env.ANALYTICS_CAPTURE_GIT_TAGS.split(',')
        : null,
      'GitHub PR ID': import.meta.env.ANALYTICS_CAPTURE_GITHUB_PR_ID,
      'GitHub PR URL': import.meta.env.ANALYTICS_CAPTURE_GITHUB_PR_URL,
    });
  }
}

showGitInfo({
  appName: 'Manager',
  commitHash: process.env.GIT_COMMIT_HASH,
  branchName: process.env.GIT_BRANCH_NAME,
  tagName: process.env.GIT_TAG_NAME,
  version: process.env.VITE_APP_VERSION,
});

document.addEventListener('DOMContentLoaded', async function () {
  if (!container) {
    container = document.getElementById('root') as HTMLElement;
    const root = ReactDOM.createRoot(container);
    await initI18n(LanguageScopes.manager);
    datadogInit();

    const managerSentryDSN = import.meta.env.FE_MANAGER_SENTRY_DSN as string;

    if (!isDevelopment && managerSentryDSN) {
      sentryInit(managerSentryDSN);
    }

    // <React.StrictMode>
    // <React.Suspense
    //   fallback={
    //     <TextTitle>Loading ...</TextTitle>
    //   }
    // >
    root.render(
      <XstateDevLogger>
        <AuthProvider>
          <RouterProvider />
        </AuthProvider>
      </XstateDevLogger>
    );
    // </React.Suspense>
    // </React.StrictMode>
  }
});
